<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <v-text-field v-model="fields['title-review']" label="Title" />
        </div>
        <v-row>
          <v-col cols="6">
            <div style="margin-bottom: 20px">
              <div>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['title-color']"
                    @change="handleChangeTitleColor"
                  />
                  <v-text-field v-model="fields['title-color']" label="Title Color" />
                  <v-btn @click="handleResetTitleColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div style="margin-bottom: 20px">
              <div>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['background-color']"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['background-color']" label="Background Color" />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>

        <div style="margin-bottom: 20px">
          <label class="label-input">Pagination Colors</label>
          <v-row>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-active-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-active-color']"
                      @change="handleChangePaginationActiveColor"
                    />
                    <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                    <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="pagination-inactive-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['pagination-inactive-color']"
                      @change="handleChangePaginationInactiveColor"
                    />
                    <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                    <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- Slides Per View -->
        <div class="mb-4">
          <label class="label-input">Slides Per View</label>
          <p class="text-caption">The viewport is based on the description’s width, not the window’s width.</p>
          <v-row>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.mobile.slidesPerView"
                  label="Mobile"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.tablet.slidesPerView"
                  label="Tablet"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-text-field
                  v-model.number="fields.breakpoints.desktop.slidesPerView"
                  label="Desktop"
                  type="number"
                  :rules="[v => v > 0 || 'Slides Per View must be greater than 0']"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>

        <div class="wrap-reviews-form">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 10px">Reviews ({{ fields['body-review'].length }})</label>
            <v-btn small text color="primary" @click="handleAddReview">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Review</span>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-text-color']"
                      @change="handleChangeCardTextColor"
                    />
                    <v-text-field v-model="fields['card-text-color']" label="Text Color" />
                    <v-btn @click="handleResetCardTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="background"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-background-color']"
                      @change="handleChangeCardBackground"
                    />
                    <v-text-field v-model="fields['card-background-color']" label="Background Color" />
                    <v-btn @click="handleResetCardBackground" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields['body-review']" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Review {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveReview(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="wrap-review-form">
                    <v-text-field v-model="item.name" label="Reviewer Name" />
                    <div class="mb-5">
                      <label>Rating</label>
                      <v-rating
                        color="warning"
                        background-color="#c1c1c1"
                        empty-icon="mdi-star-outline"
                        full-icon="mdi-star"
                        half-icon="mdi-star-half-full"
                        hover
                        length="5"
                        size="35"
                        v-model="item.rating"
                      ></v-rating>
                    </div>
                    <div class="mb-5">
                      <label>Review Image</label>
                      <UploadImage
                        @callback="obj => handleUploadImage(obj, i)"
                        :image="{ imageSrc: item.image }"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveImage(i)"
                      />
                    </div>
                    <div class="mb-5">
                      <label>Quote</label>
                      <ckeditor :editor="editor" v-model="item.quote" :config="editorConfig" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeepObject } from '../common/utils';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { replaceImageUrl } from '../common/utils';

export default {
  name: 'ReviewGridKindLokalSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Review Grid Kind Lokal Section',
        'title-review': 'Our Happy Stories',
        'card-background-color': '#f6f6f6',
        'card-text-color': '#000000',
        'body-review': [
          {
            name: 'Chloe S.',
            rating: 5,
            image: 'https://example.com/image1.jpg',
            quote: 'Keeps them busy in the best way',
          },
        ],
        'title-color': '',
        'background-color': '',
        'pagination-active-color': '#000000',
        'pagination-inactive-color': '#cccccc',
        breakpoints: {
          mobile: {
            slidesPerView: 1,
          },
          tablet: {
            slidesPerView: 2,
          },
          desktop: {
            slidesPerView: 3,
          },
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updatedSection = {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtmlFromData.sectionReviewGridKindLokal(this.sectionEditor.section.html, this.fields),
      };
      this.$emit('update:section', updatedSection);
      this.handleClosePopup();
    },
    handleAddReview() {
      this.fields['body-review'].push({
        name: 'New Reviewer',
        rating: 5,
        image: replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2025/08/19/image-68a3f035e35b6549cc3f6646.webp?w=500&h=50&q=80',
        ),
        quote: 'New review quote',
      });
    },
    handleRemoveReview(index) {
      this.fields['body-review'].splice(index, 1);
    },
    handleUploadImage(obj, index) {
      if (obj && obj.imageSrc) {
        this.fields['body-review'][index].image = obj.imageSrc;
      }
    },
    handleRemoveImage(index) {
      this.fields['body-review'][index].image = '';
    },
    handleChangeTitleColor(event) {
      this.fields['title-color'] = event.target.value;
    },
    handleChangeBackgroundColor(event) {
      this.fields['background-color'] = event.target.value;
    },
    handleChangeCardTextColor(event) {
      this.fields['card-text-color'] = event.target.value;
    },
    handleChangeCardBackground(event) {
      this.fields['card-background-color'] = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['background-color'] = '';
    },
    handleResetTitleColor() {
      this.fields['title-color'] = '';
    },
    handleResetCardTextColor() {
      this.fields['card-text-color'] = '#000000';
    },
    handleResetCardBackground() {
      this.fields['card-background-color'] = '#f6f6f6';
    },
    handleChangePaginationActiveColor(event) {
      this.fields['pagination-active-color'] = event.target.value;
    },
    handleChangePaginationInactiveColor(event) {
      this.fields['pagination-inactive-color'] = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '#000000';
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '#cccccc';
    },
  },
  mounted() {
    if (this.sectionEditor.sectionExtract) {
      this.fields = cloneDeepObject(this.sectionEditor.sectionExtract);
    }
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal.sectionExtract) {
          this.fields = cloneDeepObject(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.label-input {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.wrap-review-form {
  padding: 16px 0;
}

.wrap-reviews-form {
  margin-top: 20px;
}

.header-modal,
.footer-modal {
  padding: 0 24px;
  border-bottom: 1px solid #e0e0e0;
}

.footer-modal {
  border-top: 1px solid #e0e0e0;
  border-bottom: none;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.gap-3 {
  gap: 12px;
}
</style>
